import ImageCropStyle from "../templates/ImageCrop.style";
var imageCropData = {
  name: 'imageCrop',
  data: [{
    iconSize: 80
  }],
  onlyTemplate: {
    base: ImageCropStyle
  }
};
export default imageCropData;